import { databaseSidebarActions } from '../actions'
import { TABLES } from '../constants'
import { useActions, useAppSelector } from '../../../store/hooks'
import { databasePageSelector } from '../../../store/slices/databasePage'

export function useDatabaseSidebar() {
    const selectedTable = useAppSelector(databasePageSelector.selectedTable)
    const { setSelectedTable } = useActions(databaseSidebarActions)

    return {
        selectedTable,
        tables: TABLES,
        setSelectedTable,
    }
}
